import axios from 'axios'
import { useLanguageStore } from '@/stores/languageStore'

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

const api = axios.create({
  baseURL: '/api/v1', // или /api/v2, если публичка тоже использует v2
  headers: {
    'X-CSRF-Token': csrfToken,
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

api.interceptors.request.use(config => {
  const languageStore = useLanguageStore()
  const locale = languageStore.locale || 'ru'
  config.headers['Accept-Language'] = locale
  return config
})

export default api
